import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CommonTable from "components/commonTable/CommonTable";
import "./CityConfig.scss"; 

const cityOptions = [
  { label: "Mumbai", value: "Mumbai" },
  { label: "Bangalore", value: "Bangalore" },
  { label: "Chennai", value: "Chennai" },
];

const rideTypeOptions = [
  { label: "Ride", value: "Ride" },
  { label: "Airport", value: "Airport" },
  { label: "Rental", value: "Rental" },
  { label: "Outstation", value: "Outstation" },
];

const carTypeOptions = [
  { label: "Mini", value: "Mini" },
  { label: "SUV", value: "SUV" },
  { label: "Sedan", value: "Sedan" },
  { label: "Luxury", value: "Luxury" },
];

const mockTableData = {
  header: [
    { label: "Ride Type", key: "rideType" },
    { label: "Car Type", key: "carType" },
    { label: "Bsse Rate", key: "baseRate" },
  ],
  body: [
    { id: 1, rideType: "Ride", carType: "Mini", baseRate: "₹120" },
    { id: 2, rideType: "Ride", carType: "SUV", baseRate: "₹150" },
    { id: 3, rideType: "Airport", carType: "Sedan", baseRate: "₹120" },
    { id: 4, rideType: "Rental", carType: "SUV", baseRate: "₹150" },
    { id: 5, rideType: "Outstation", carType: "Luxury", baseRate: "₹120" },
  ],
  totalCount: 5,
};

const CityConfig = () => {
  const { cityName } = useParams();
  const [selectedCity, setSelectedCity] = useState(cityName || "Bangalore");
  const [selectedRideType, setSelectedRideType] = useState("");
  const [selectedCarType, setSelectedCarType] = useState("");
  const navigate = useNavigate();

  // Handle row click to redirect to form page
  const handleRowClick = (row) => {
    navigate(`/city-config/${selectedCity}/form`, {
      state: {
        rideType: row.rideType,
        carType: row.carType,
        baseRate: row.baseRate,
      },
    });
  };

    // Handle Add button click
  const handleAddClick = () => {
    if (!selectedRideType || !selectedCarType) {
      alert("Please select both Ride Type and Car Type.");
      return;
    }

    navigate(`/city-config/${selectedCity}/form`, {
      state: {
        rideType: selectedRideType,
        carType: selectedCarType,
      },
    });
  };

  const config = {
  title: `Configure Details for ${selectedCity}`,
  formField: [
    {
      title: "", // Optional section title
      formFields: [
        {
          label: "Ride Type",
          inputType: "select",
          options: rideTypeOptions, // must be [{ label: "", value: "" }]
          onCharge: (value) => setSelectedRideType(value),
        },
        {
          label: "Car Type",
          inputType: "select",
          options: carTypeOptions,
          onCharge: (value) => setSelectedCarType(value),
        },
      ],
    },
  ],
  subtitle: [], // You can use this if you want dynamic sections
};


  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        {/* <label>
          Select City:&nbsp;
          <select
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
          >
            {cityOptions.map((c) => (
              <option key={c.value} value={c.value}>
                {c.label}
              </option>
            ))}
          </select>
        </label> */}
      </div>
      <h2>Configure Details for {selectedCity}</h2>
      <div style={{ marginBottom: 16 }}>
        <label>
          Ride Type:&nbsp;
          <select
            value={selectedRideType}
            onChange={(e) => setSelectedRideType(e.target.value)}
          >
            <option value="">-- Select Ride Type --</option>
            {rideTypeOptions.map((r) => (
              <option key={r.value} value={r.value}>
                {r.label}
              </option>
            ))}
          </select>
        </label>
        &nbsp;&nbsp;
        <label>
          Car Type:&nbsp;
          <select
            value={selectedCarType}
            onChange={(e) => setSelectedCarType(e.target.value)}
          >
            <option value="">-- Select Car Type --</option>
            {carTypeOptions.map((c) => (
              <option key={c.value} value={c.value}>
                {c.label}
              </option>
            ))}
          </select>
        </label>
        &nbsp;&nbsp;
        <button className="add-button" onClick={handleAddClick}>
          Add
        </button>
      </div>
      <CommonTable
        data={mockTableData}
        page={0}
        rowsPerPage={10}
        handleChangePage={() => {}}
        handleChangeRowsPerPage={() => {}}
        onClickTableVendor={handleRowClick}
        isClickable={true}
      />
    </div>
  );
};

export default CityConfig;